@if (vm$ | async; as vm) {
  <div class="validation-results">
    @if (vm.inProgress) {
      <animated-border-wrapper class="validation-results__alert">
        <jui-alert-block
          size="sm"
          [color]="vm.blockColor"
          [iconName]="vm.iconName"
          [titleText]="vm.title">
          {{vm.message}}
        </jui-alert-block>
      </animated-border-wrapper>
    } @else {
      <jui-alert-block
        class="validation-results__alert"
        size="sm"
        [color]="vm.blockColor"
        [iconName]="vm.iconName"
        [titleText]="vm.title">
        {{vm.message}}
      </jui-alert-block>
    }

    @if (vm.showQualityIssues) {
      <div class="validation-results__quality-issues">
        <div class="validation-results__section-title">{{vm.qualityIssuesSectionTitle}}</div>
        <ul class="validation-results__list">
          @for (issue of vm.qualityIssues; track issue) {
            <li class="validation-results__list-item">{{issue}}</li>
          }
        </ul>
      </div>
    }

    @if (vm.showWarnings) {
      <div class="validation-results__warnings">
        <div class="validation-results__section-title">{{vm.warningsSectionTitle}}</div>
        <ul class="validation-results__list">
          @for (warning of vm.warnings; track warning) {
            <li class="validation-results__list-item">{{warning}}</li>
          }
        </ul>
      </div>
    }

    @if (vm.showReassuranceMessage) {
      <div class="validation-results__reassurance">
        {{vm.reassuranceMessage}}
      </div>
    }
  </div>
}
